import { render, staticRenderFns } from "./TiktokInputs.vue?vue&type=template&id=bc802138&scoped=true"
import script from "./TiktokInputs.vue?vue&type=script&lang=js"
export * from "./TiktokInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc802138",
  null
  
)

export default component.exports